import type { PremiumPlanId } from '~/types/premium'

/**
 * Checkout needs a session. A signed-out visitor who clicks "buy" used to get a
 * toast telling them to log in and nothing else to do, so instead we take them
 * to sign-up and explain there why they landed on that page.
 *
 * The chosen plan is parked first, so /auth/callback (or the login form) can
 * reopen the same checkout once the account exists.
 */
export function useRequireAccount() {
  const { setPendingPlan } = usePendingPurchase()

  async function redirectToSignup(planId?: PremiumPlanId) {
    if (planId) setPendingPlan(planId)

    await navigateTo({
      path: '/registration',
      query: { reason: 'purchase' },
    })
  }

  return { redirectToSignup }
}
